export default class IndexController {
  /* @ngInject */
  constructor(user, smartVault, $state) {
    if (!smartVault.integrated) {
      $state.go("integrate");
    } else if (
      !user.organizations ||
      !user.organizations.length ||
      !user.defaultOrganization
    ) {
      $state.go("createOrganizations");
    } else {
      $state.go("app.dashboard", {
        organization: user.defaultOrganization.slug,
      });
    }
  }
}
